module.exports = __webpack_public_path__ + "static/media/intro-hero-wheel.959089e3.png";